export default __webpack_public_path__ + "85a61993ec142c723c814d0fad12a56e.svg";